import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout.js';
import Placeholder from './components/Placeholder.js';
import Login from './pages/Login.js';
import Today from './pages/Today.js';
import Plan from './pages/Plan.js';
import Calendar from './pages/Calendar.js';
import Money from './pages/Money.js';
import Trends from './pages/Trends.js';
import Nutrition from './pages/Nutrition.js';
import Training from './pages/Training.js';
import Records from './pages/Records.js';
import Concerns from './pages/Concerns.js';
import Journal from './pages/Journal.js';
import Settings from './pages/Settings.js';
import Coach from './pages/Coach.js';
import Admin from './pages/Admin.js';
import Contacts from './pages/Contacts.js';
import Library from './pages/Library.js';
import Home from './pages/Home.js';
import Tasks from './pages/Tasks.js';
import Inbox from './pages/Inbox.js';
import People from './pages/People.js';
import Person from './pages/Person.js';
import Projects from './pages/Projects.js';
import Project from './pages/Project.js';
import Workspace from './pages/Workspace.js';
import Obligations from './pages/Obligations.js';
import Services from './pages/Services.js';
import Documents from './pages/Documents.js';
import Belongings from './pages/Belongings.js';
import Trips from './pages/Trips.js';
import Trip from './pages/Trip.js';
import Notes from './pages/Notes.js';
import Timeline from './pages/Timeline.js';
import Agents from './pages/Agents.js';
import AgentRun from './pages/AgentRun.js';
import Connections from './pages/Connections.js';
import Brief from './pages/Brief.js';
import Coffee, { CoffeeBean, CoffeeShot } from './pages/Coffee.js';

/**
 * Route table (spec §6, CONTRACT). Paths are fixed: pages replace an element,
 * never a path. The server's SPA fallback serves index.html for every one of
 * them, so no server route may claim a GET on these paths.
 */
export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        {/* The old home page, unchanged; Library tile "Health today". */}
        <Route path="/health" element={<Today />} />

        {/* Life OS */}
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/library" element={<Library />} />
        <Route path="/people" element={<People />} />
        <Route path="/people/:id" element={<Person />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<Project />} />
        <Route path="/w/:key" element={<Workspace />} />
        <Route path="/obligations" element={<Obligations />} />
        <Route path="/services" element={<Services />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/belongings" element={<Belongings />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trips/:id" element={<Trip />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/agents/runs/:id" element={<AgentRun />} />
        <Route path="/connections" element={<Connections />} />
        <Route path="/brief/:id" element={<Brief />} />

        {/* Existing pages, reached from the Library */}
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/money" element={<Money />} />
        <Route path="/money/:tab" element={<Money />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/training" element={<Training />} />
        <Route path="/nutrition" element={<Nutrition />} />
        <Route path="/coffee" element={<Coffee />} />
        <Route path="/coffee/beans/:id" element={<CoffeeBean />} />
        <Route path="/coffee/:id" element={<CoffeeShot />} />
        <Route path="/records" element={<Records />} />
        <Route path="/concerns" element={<Concerns />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/settings" element={<Settings />} />
        <Route
          path="*"
          element={<Placeholder title="Not found" kicker="404" note="Nothing lives at this address." />}
        />
      </Route>
    </Routes>
  );
}
